import React, { useContext, useCallback } from 'react';
import c from 'classnames';
import CommentBox from '../../../CommentBox2/presets/CommentBox';
import { generateReplyEditorId } from '../../utils';
import { CommentContext } from '../../CommentContext';
import s from './ReplyCommentBox.scss';
/** Our `CommentBox` with some comment specific props passed through. */
var ReplyCommentBox = function (_a) {
    var canPostComment = _a.canPostComment, className = _a.className, nc = _a.nc, onReplyPosted = _a.onReplyPosted;
    var _b = useContext(CommentContext), comment = _b.comment, setEditingState = _b.setEditingState;
    var onCloseEditor = useCallback(function () {
        setEditingState('none');
    }, [setEditingState]);
    var onReplyDone = useCallback(function (result) {
        setEditingState('none');
        onReplyPosted && result.comment && onReplyPosted(result);
    }, [onReplyPosted, setEditingState]);
    return (React.createElement(CommentBox, { onPublishSuccess: onReplyDone, id: generateReplyEditorId(comment), className: c(s['root'], className), commentableType: comment.typeId, commentableItemId: comment.itemId, replyComment: comment, autoFocus: true, onClose: onCloseEditor, canPostComment: !!canPostComment, nc: nc }));
};
ReplyCommentBox.displayName = 'ReplyCommentBox';
export default ReplyCommentBox;
//# sourceMappingURL=ReplyCommentBox.js.map